var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"id":"containerProduto"}},[_c('listaProdutoCard',{attrs:{"items":_vm.itemsFiltered,"name":"broker"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }